import React, { Component } from "react";
import { inject } from "mobx-react";
import PropTypes from "prop-types";
import FeaturedItemView from "./featuredItemView/featuredItemView";
import GeneralItemView from "./generalItemView/generalItemView";
import {
  ContentStorePropTypes,
  BaseTagStorePropTypes,
  AutoCompletePropTypes
} from "../../utilities/propTypes";

class LearningItemView extends Component {
  componentDidMount() {
    this.loadInitialData();
  }

  componentDidUpdate() {
    this.loadInitialData();
  }

  loadInitialData = () => {
    const {
      featuredItemStore,
      generalItemStore,
      baseTagStore,
      autoCompleteStore,
      baseTag
    } = this.props;

    autoCompleteStore.clear();
    baseTagStore.updateBaseTag(baseTag);
    const featuredPromise = featuredItemStore.load(baseTag);
    const generalPromise = generalItemStore.load(baseTag);
    Promise.all([featuredPromise, generalPromise]);
  };

  render() {
    return (
      <div className="container">
        <FeaturedItemView />
        <GeneralItemView />
      </div>
    );
  }
}

LearningItemView.propTypes = {
  baseTag: PropTypes.string.isRequired,
  featuredItemStore: ContentStorePropTypes.isRequired,
  generalItemStore: ContentStorePropTypes.isRequired,
  baseTagStore: BaseTagStorePropTypes.isRequired,
  autoCompleteStore: AutoCompletePropTypes.isRequired
};

export default inject(
  "featuredItemStore",
  "generalItemStore",
  "baseTagStore",
  "autoCompleteStore"
)(LearningItemView);
